export function appointmentWaMessage(order, merchantName, customerName, note) {
  return [
    `KELATE Appointment Request ${order?.orderNumber || ''}`,
    `Business: ${merchantName}`,
    `Customer: ${customerName}`,
    note ? `Details: ${note}` : '',
    '',
    'Hi, I would like to make an appointment. Please let me know your available time slots.',
  ].filter(Boolean).join('\n');
}


export function waPhone(phone) {
  let p = (phone || '').replace(/\D/g, '');
  if (p.startsWith('0')) p = `6${p}`;
  if (p && !p.startsWith('60')) p = `60${p}`;
  return p;
}

export function waLink(phone, text) {
  const p = waPhone(phone);
  return `https://wa.me/${p}?text=${encodeURIComponent(text)}`;
}

export function orderWaMessage(order, merchantName) {
  const items = order.items.map((i) => `- ${i.name}${i.variant ? ` (${i.variant})` : ''} x${i.qty} @ RM${i.price.toFixed(2)}`).join('\n');
  return [
    `KELATE Order ${order.orderNumber}`,
    `Store: ${merchantName}`,
    `Customer: ${order.customerName} (${order.customerPhone})`,
    `Deliver to: ${order.address.line1}, ${order.address.district}, ${order.address.state}`,
    '',
    'Items:',
    items,
    '',
    `Items: RM${order.itemSubtotal.toFixed(2)}`,
    `Delivery: RM${order.deliveryFee.toFixed(2)}`,
    `Total: RM${order.totalCustomerDue.toFixed(2)}`,
    `Payment: ${order.paymentMethod === 'WALLET' ? 'Paid via KELATE Wallet' : order.paymentMethod === 'TNG_QR' ? 'TNG QR on delivery' : order.paymentMethod === 'BANK_TRANSFER' ? 'Bank transfer on delivery' : 'Cash on delivery'}`,
    '',
    'Please reply to confirm you have received this order.',
  ].join('\n');
}
